var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-network-share"},_vm._l((_vm.socialNetworks),function(network,index){return _c('ShareNetwork',{key:index,class:[
      'social-network-share-button',
      network.name
    ],attrs:{"network":network.name,"url":_vm.url,"title":_vm.title,"hashtags":"MasPocoVendo"},nativeOn:{"click":function($event){return _vm.pushToDataLayer('Share modal', ("Share to " + (network.name)))}}},[_c('font-awesome-icon',{staticClass:"social-network-share-icon",attrs:{"icon":network.icon}})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf59e0bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SocialNetworkShare.vue
// module id = null
// module chunks = 